import React, { FC, useState } from 'react';
import { ReactComponent as DeletePartnerIcon } from 'assets/icons/delete.svg';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { PartnerType } from 'models/partner.model';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';
import { handleApiError } from 'utils/functions';

interface DeletePartnerModalType {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  partner: PartnerType;
  handleDeletePartner: (id: string) => void;
}

interface DeletePartnerModalFooterType {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}

const DeletePartnerModalFooter: FC<DeletePartnerModalFooterType> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const DeletePartnerModal: FC<DeletePartnerModalType> = ({
  show,
  onClose,
  onConfirm,
  partner,
  handleDeletePartner
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const sendDetails = async () => {
    try {
      setLoading(true);
      await apiService.delete(`logistics/super-admin/logistics-company/${partner.id}`, {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Partner deleted successfully' />);
      handleDeletePartner(partner.id);
      onConfirm();
    } catch (error: any) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Delete Partner'
      titleIcon={<DeletePartnerIcon />}
      titleIconColor='danger'
      onRequestClose={onClose}
      footer={
        <DeletePartnerModalFooter loading={loading} onCancel={onClose} onConfirm={sendDetails} />
      }>
      <p>Are you sure you want to delete {partner?.name}</p>
    </BaseModal>
  );
};

export default DeletePartnerModal;
